type PanelProps = {
    children: React.ReactNode;
    title?: React.ReactNode;
    /** Shown to the right of the title. */
    aside?: React.ReactNode;
    /** `sunk` uses `--color-bg-sunk` instead of surface white. */
    tone?: 'surface' | 'sunk';
    padding?: 'normal' | 'tight';
};

export function Panel({ children, title, aside, tone = 'surface', padding = 'normal' }: PanelProps) {
    return (
        <section
            className={`rounded-lg border border-border ${tone === 'sunk' ? 'bg-bg-sunk' : 'bg-surface'} ${
                padding === 'tight' ? 'p-4' : 'p-5 sm:p-6'
            }`}
        >
            {title || aside ? (
                <header className="mb-4 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 border-b border-border pb-3">
                    {title ? <h2 className="eyebrow text-text">{title}</h2> : null}
                    {aside ? <div className="text-sm text-text-muted">{aside}</div> : null}
                </header>
            ) : null}

            {children}
        </section>
    );
}
